export default __webpack_public_path__ + "static/media/partner-banner-mobile.9eb999a7.png";